/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CounterIcon24Solid = forwardRef('CounterIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.5 10.5a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0v-3Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 4a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H6Zm2.5 4A2.5 2.5 0 0 0 6 10.5v3a2.5 2.5 0 0 0 5 0v-3A2.5 2.5 0 0 0 8.5 8Zm6-2v2.477a1 1 0 1 0 2 0V6H18v2.478a2.5 2.5 0 0 1-5 0V6h1.5Zm2.5 7a.75.75 0 0 0-1.28-.53l-2.25 2.25a.75.75 0 1 0 1.06 1.06l.97-.97v3.195H17V13Z" })));
});
